import { BusinessExtraInfo } from './business-extra-info';
import { BusinessInfo } from './business-info';
import { BusinessMediaInfo } from './business-media-info';
import { BusinessSliderInfo } from './business-slider-info';
import { BusinessTimeInfo } from './business-time-info';

export class BusinessPaginData {
    BusinessInfo?: BusinessInfo[] | any;
    BusinessSliderInfo?: BusinessSliderInfo[] | any;
    BusinessMediaInfo?: BusinessMediaInfo[] | any;
    BusinessExtraInfo?: BusinessExtraInfo[] | any;
    BusinessTimeInfo?: BusinessTimeInfo[] | any;
    BusinessCount?: any;
}
